
<template>
        <div class="fixcon">
            <van-nav-bar :fixed='true'>
                     <template #title>
                        <span v-if="title!=''">{{title}}</span>
                     </template>
                     <template #left>
                        <van-icon name="arrow-left" size="18" @click="goback()" :color='color' v-if="showarrow"/>
                     </template>
                     <template #right>
                        <slot name="rightcon"></slot>
                     </template>
            </van-nav-bar>
        </div>
</template>
<script>
import { NavBar,Icon} from 'vant';
export default {
   name: 'NavTop',
   props:{
      title:{type:String,default:''},
      color:{type:String,default:'#333333'},
      islink:{type:Boolean,default:false},
      linkurl:{type:String,default:'/index'},
      showarrow:{type:Boolean,default:true}
   },
   methods: {
      goback() {
         if(this.islink){
            this.$go(this.linkurl)
         }else{
            this.$router.go(-1);
         } 
      }
   },
   components: {
        [NavBar.name]: NavBar,
        [Icon.name]: Icon
   }
}
</script>
<style scoped>
.fixcon{height: 46px;margin-bottom: 10px;}   
::v-deep .van-search{position:fixed;width:100%;top:0;left:0;}
::v-deep .van-field__right-icon{display:flex;}
::v-deep [class*=van-hairline]::after{border: none;}
</style>